export var gridLayoutContainer = function (_a) {
    var columns = _a.columns, rows = _a.rows, areas = _a.areas, justifyContent = _a.justifyContent, alignContent = _a.alignContent, justifyItems = _a.justifyItems, alignItems = _a.alignItems;
    return ({
        display: 'grid',
        gridTemplateColumns: columns.join(' '),
        gridTemplateRows: rows.join(' '),
        gridTemplateAreas: areas.map(function (rowItems) { return "\"" + rowItems.join(' ') + "\""; }).join(' '),
        justifyContent: justifyContent,
        alignContent: alignContent,
        justifyItems: justifyItems,
        alignItems: alignItems,
    });
};
export var gridLayoutItem = function (area, _a) {
    var _b = _a === void 0 ? {} : _a, justifySelf = _b.justifySelf, alignSelf = _b.alignSelf;
    return ({
        gridArea: area,
        justifySelf: justifySelf,
        alignSelf: alignSelf,
    });
};
